// Root reducer

import { combineReducers } from 'redux';

import authReducer from './authReducer';
import loadingReducer from './loadingReducer';
import merchantReducer from './merchantReducers';
import navReducer from './navReducer';
import notificationReducer from './notificationReducer';
import prizeReducer from './prizeReducer';
import programReducer from './programReducer';
import rewardReducer from './rewardReducer';
import loyaltyConfigItemsReducer from './loyaltyConfigReducer';

const rootReducer = combineReducers({
    auth: authReducer,
    program: programReducer,
    navigation: navReducer,
    notification: notificationReducer,
    loading: loadingReducer,
    loyaltyConfig: loyaltyConfigItemsReducer,
    prize: prizeReducer,
    reward: rewardReducer,
    merchant: merchantReducer,
});

export default rootReducer;
